import { render, staticRenderFns } from "./RwFlexOptIn.vue?vue&type=template&id=15aa9446&scoped=true"
import script from "./RwFlexOptIn.vue?vue&type=script&lang=ts"
export * from "./RwFlexOptIn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aa9446",
  null
  
)

export default component.exports